module.exports = __webpack_public_path__ + "static/media/ZapytanieOfertowe5.7d50f474.pdf";